<div class="col-lg-12">
    <div class="card">
        <div class="card-body">
            <h2>{{ 'terms' | localise }}</h2>

            <div id="text" [innerHTML]="termsAndConditions.text"></div>
        </div>
    </div>
</div>
